if (!customElements.get("product-price")) {
    customElements.define(
        "product-price",
        class ProductPrice extends HTMLElement {


            constructor() {
                super();

                const isDynamic = (this.dataset.dynamic?.toLowerCase?.() === 'true');
                if(!isDynamic) return;


                //Shopify base price, in pennies etc
                const unitPriceString = this.dataset.unitPrice;
                if(!unitPriceString){
                    return;
                } 

                try {
                    this.price = {
                        amount: parseFloat(unitPriceString) / 100,
                        prefix: this.dataset.prefix ?? "",
                        suffix:  this.dataset.suffix ?? ""
                    };
                } catch(e){
                    console.error(e);
                }

                const formString = this.dataset.form;
                this.form = formString ? document.querySelector(formString) : null;

                if(!this.form){
                    const container = this.closest('product-info');
                    const section = container?.dataset.section ?? null;
                    if(section){
                        this.form = container.querySelector(`#product-form-${section}`) ?? null;
                    }
                }

                this.onInputChange = this.onInputChange.bind(this);
            }

            connectedCallback() {
                if(!this.form) return;

                this.field = this.form?.querySelector('[name="quantity"]');
                this.observer = new MutationObserver(this.onInputChange);

                if (this.field) {
                    this.field.addEventListener('change', this.onInputChange);
                    this.field.addEventListener('input', this.onInputChange);
                    this.observer.observe(this.field, { attributes: true });
                    this.onInputChange();
                }
            }

            disconnectedCallback() {
                this.field?.removeEventListener('change', this.onInputChange);
                this.field?.removeEventListener('input', this.onInputChange);
                this.observer?.disconnect();
            }

            onInputChange(){
                const qty = this.field?.value ?? null;
                if(!qty || this.price?.amount == null || this.price?.amount == undefined) return;
                this.innerText = `${this.price.prefix ?? ""}${(this.price.amount * qty).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2})}${this.price.suffix ?? ""}`
            }
        },
    );
}
